import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
  CircularProgress,
  Divider,
} from '@mui/material';
import { useAppSelector } from '../../store/hooks';

interface ViewClarificationSchemaModalProps {
  open: boolean;
  onClose: () => void;
}

const ViewClarificationSchemaModal: React.FC<ViewClarificationSchemaModalProps> = ({ open, onClose }) => {
  const { selectedSchema, loading, schemas } = useAppSelector((state) => state.clarificationSchemas);

  const parentSchemaName = selectedSchema?.parentSchemaId
    ? schemas.find((s) => s.id === selectedSchema.parentSchemaId)?.entity || selectedSchema.parentSchemaId
    : null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Detalle de Esquema de Clarificación</DialogTitle>
      <DialogContent>
        {loading ? (
          <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
            <CircularProgress />
          </Box>
        ) : selectedSchema ? (
          <Box sx={{ mt: 2 }}>
            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Entidad
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedSchema.entity}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Tipo
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedSchema.type}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Match Entities
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedSchema.matchEntities.length > 0 ? selectedSchema.matchEntities.join(', ') : '(ninguna)'}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Related Entities
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedSchema.relatedEntities.length > 0 ? selectedSchema.relatedEntities.join(', ') : '(ninguna)'}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Final Query Template
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedSchema.finalQueryTemplate || '(vacío)'}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Person Keywords
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedSchema.personKeywords?.length > 0 ? selectedSchema.personKeywords.join(', ') : '(ninguna)'}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Descripción
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedSchema.description}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Palabras Clave
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedSchema.triggerKeywords.join(', ')}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Máx. Resultados sin Clarificación
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedSchema.maxResultsWithoutClarification}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Esquema Padre
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {parentSchemaName || '(ninguno)'}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Fecha de Creación
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedSchema.createdAt}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Creado Por
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedSchema.createdBy}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Fecha de Actualización
              </Typography>
              <Typography variant="body1" sx={{ mb: 2 }}>
                {selectedSchema.updatedAt}
              </Typography>
              <Divider />
            </Box>

            <Box sx={{ mb: 2 }}>
              <Typography variant="subtitle2" color="text.secondary">
                Actualizado Por
              </Typography>
              <Typography variant="body1">
                {selectedSchema.updatedBy}
              </Typography>
            </Box>
          </Box>
        ) : (
          <Typography>No hay esquema seleccionado</Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewClarificationSchemaModal;
